// components/Modal.js
import React from 'react';
import styles from './ModalUI.module.css';

const ModalUI = ({ isOpen, onClose, children, customClass }) => {
  if (!isOpen) return null;

  // Prevents scrolling when modal is open
  React.useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = 'auto'; }
  }, []);

  return (
    <div className={`${styles.overlay}  ${customClass}`} onClick={onClose}>
      <div className={`${styles.modal} bg-tt-100 `} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button>
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default ModalUI;
